/* eslint-disable no-unused-vars */
import api from '@utils/api'

export const getAllBlacklistDomains = () => async (_dispatch, _getState) => {
  const response = await api.getAllBlacklistDomains()
  return response
}

export const addtDomainToBlacklist = (newDomain) => async (_dispatch, _getState) => {
  const data = {
    dominio: newDomain
  }
  const response = await api.addtDomainToBlacklist(data)
  return response
}

export const deleteDomain = ({domain, justification}) => async (_dispatch, _getState) => {
  const response = await api.deleteDomain(domain)
  return response
}
